export default "__VITE_ASSET__B3pbRgk5__";